import Settings from '../../../base/menu/airdome/Settings';

const settings: Settings = {
  categoryName: 'Nastavení',
  current: 'Aktuální'
};

export default settings;
